// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2_L0B","FooterSectionA":"Footer_FooterSectionA__C_ZSA","FooterSectionB":"Footer_FooterSectionB__3FmMY","FooterIcons":"Footer_FooterIcons__21Nvz"};